const origin = {
  leadOriginAll: 'Alle Kontakte',
  leadOriginConversion: 'Generierte Kontakte',
  leadOriginImport: 'Angelegte/Importierte Kontakte'
}

export const originForSelect = Object.entries(origin).map(([value, text]) => ({ value, text }))

export default origin
